import { render, staticRenderFns } from "./PublicFolders.vue?vue&type=template&id=5b54cf0b&"
import script from "./PublicFolders.vue?vue&type=script&lang=js&"
export * from "./PublicFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports